import '../index.scss';
import React, { Component } from 'react';
import { convertUnixtodate, getFieldValue } from '../../shared/services/common-functions';
import LabeledDatePicker from '../../shared/components/labeled-date-picker';
import LabeledInput from '../../shared/components/labeled-input';
import PropTypes from 'prop-types';
import { isAlphanumeric } from '../../shared/services/validator';

class MachineWarranty extends Component {

    state = {
        editableFields: {},
    }

    defaultProp = {
        modelCode: getFieldValue( this.props.claimDetails.product.modelCode ),
        modelYear: getFieldValue( this.props.claimDetails.product.modelYear ),
        buildDate: this.props.claimDetails.product.buildDate === 0 ? null
            : new Date( this.props.claimDetails.product.buildDate * 1000 ),
        branch: getFieldValue( `${this.props.claimDetails.geoGraphicBranch.corrected} - ${
            this.props.claimDetails.geoGraphicBranch.correctedDescription}` ),
        useAmountValue: getFieldValue( this.props.claimDetails.originalClaim
            .useAmountValue ),
    }

    initialDeliveryDate = 0;

    deliveryDate = 0;

    useAmountUnit = '';

    customerEndUseCode = '';

    useMonth = '';

    useYear = '';

    warrantyExpirationDate = 0;

    powertrainWarrantyExpirationDate = 0;

    extendedWarrantyCode = '';

    warrantyCode = '';

    participationCode = '';

    policyAdjustmentCode = '';

    totalDeductibleAmount = '';

    diagnosticAmount = '';

    diagnosticHours = '';

    partsUse = '';

    installationDate = 0;

    isCmpInpEdited = false;


    componentWillMount = () => {

        this.assignValue( this.props.claimDetails );

        this.setState( {
            editableFields: this.defaultProp,
        } );

    }

    assignValue = claimDetails => {

        if ( claimDetails !== undefined ) {

            this.useMonth = getFieldValue( this.props.claimDetails.useMonth );

            this.useYear = getFieldValue( this.props.claimDetails.useYear );

            this.participationCode = getFieldValue( this.props.claimDetails.participationCode );

            if ( claimDetails.product !== undefined ) {

                this.initialDeliveryDate = convertUnixtodate(
                    getFieldValue( this.props.claimDetails.product.initialDeliveryDate ),
                );

                this.deliveryDate = convertUnixtodate(
                    getFieldValue( this.props.claimDetails.product.deliveryDate ),
                );

            }

            if ( claimDetails.originalClaim !== undefined ) {

                this.useAmountUnit = getFieldValue( this.props.claimDetails.originalClaim
                    .useAmountUnit );

                this.partsUse = getFieldValue( claimDetails.originalClaim.partsUse );

                this.installationDate = convertUnixtodate(
                    getFieldValue( claimDetails.originalClaim.installationDate ),
                );

            }

            if ( claimDetails.customer !== undefined ) {

                this.customerEndUseCode = getFieldValue( this.props.claimDetails.customer
                    .customerEndUseCode );

            }

            if ( claimDetails.warranty !== undefined ) {

                this.warrantyExpirationDate = convertUnixtodate(
                    getFieldValue( this.props.claimDetails.warranty.warrantyExpirationDate ),
                );

                this.powertrainWarrantyExpirationDate = convertUnixtodate(
                    getFieldValue( this.props.claimDetails.warranty
                        .powertrainWarrantyExpirationDate ),
                );

                this.extendedWarrantyCode = getFieldValue( this.props.claimDetails.warranty
                    .extendedWarrantyCode );

                this.warrantyCode = getFieldValue( this.props.claimDetails.warranty.warrantyCode );

                this.policyAdjustmentCode = getFieldValue( this.props.claimDetails
                    .warranty.policyAdjustmentCode );

            }

            if ( claimDetails.amounts !== undefined ) {

                this.totalDeductibleAmount = getFieldValue( this.props.claimDetails.amounts
                    .totalDeductibleAmountUsd );

                this.diagnosticAmount = getFieldValue( this.props.claimDetails.amounts
                    .diagnosticAmountUsd );

                this.diagnosticHours = getFieldValue( this.props.claimDetails.amounts
                    .diagnosticHours );

            }

        }

    }

    componentWillReceiveProps = nextProps => {

        this.assignValue( nextProps.claimDetails );

        const obj = {
            modelCode: getFieldValue( nextProps.claimDetails.product.modelCode ),
            modelYear: getFieldValue( nextProps.claimDetails.product.modelYear ),
            buildDate: nextProps.claimDetails.product.buildDate === 0 ? null
                : new Date( nextProps.claimDetails.product.buildDate * 1000 ),
            branch: getFieldValue( nextProps.claimDetails.geoGraphicBranch.corrected ),
            useAmountValue: getFieldValue( nextProps.claimDetails.originalClaim
                .useAmountValue ),
        };
        this.defaultProp = obj;
        this.setState( {
            editableFields: obj,
        } );

    }

    onEditBtnClicked = () => {

        this.props.enableEditCmp( 'Machine Warranty' );

    }


    onSaveBtnClicked = () => {

        if ( this.isCmpInpEdited ) {

            const updatedData = {
                modelCode: this.props.claimDetails.product.modelCode ===
                    this.state.editableFields.modelCode ?
                    null : this.state.editableFields.modelCode,

                modelYear: this.props.claimDetails.product.modelYear ===
                    this.state.editableFields.modelYear ? null :
                    this.state.editableFields.modelYear,

                branch: this.props.claimDetails.geoGraphicBranch.corrected ===
                    this.state.editableFields.branch ? null :
                    this.state.editableFields.branch,

                buildDate: this.props.claimDetails.product.buildDate ===
                    new Date( this.state.editableFields.buildDate ).getTime() / 1000 ?
                    null : new Date( this.state.editableFields.buildDate ).getTime() / 1000,

                machineHourCount: this.props.claimDetails.originalClaim
                    .useAmountValue === this.state.editableFields.useAmountValue ?
                    null : this.state.editableFields.useAmountValue,
            };

            this.props.updateClaim( 'machineWarranty', updatedData );

        } else this.onCancelBtnClicked();

    }

    onCancelBtnClicked = () => {

        if ( this.props.enableEditCmp( 'Machine Warranty' ) ) {

            this.setState( {
                editableFields: this.defaultProp,

            } );

        }

    }

    handleDateChange = data => {

        const updatedVal = { ...this.state.editableFields };
        updatedVal.buildDate = data;
        this.isCmpInpEdited = true;

        this.setState( {
            editableFields: updatedVal,
        } );

    }

    handleUpdate = val => {

        const updatedVal = { ...this.state.editableFields };
        const numb = isAlphanumeric( val.target.value.trim() );
        if ( numb ) {

            updatedVal[val.target.name] = val.target.value;
            this.isCmpInpEdited = true;

            this.setState( {
                editableFields: updatedVal,
            } );

        }

    }

    render () {

        return (

            <div className="machine-info ">
                <section className="generic-machine-information">

                    <header>
                        {this.props.isComponentEdit && (
                            <h4 className="page-header">
                                <i title="Edit" className={`fa fa-edit ${!this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onEditBtnClicked} />
                                <i className={`fa fa-save ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onSaveBtnClicked} />
                                <i className={`fa fa-remove ${this.props.isEdit ? 'show' : 'hide'}`} onClick={this.onCancelBtnClicked} />
                            </h4>
                        )}
                    </header>

                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="modelCode"
                                isEditable={this.props.isEdit}
                                label="Model Number"
                                value={this.state.editableFields.modelCode}
                                onChange={this.handleUpdate.bind( this )}
                            />
                        </div>
                        <div className="four-cols">

                            <LabeledInput
                                className="basic-claim-info"
                                name="modelYear"
                                isEditable={this.props.isEdit}
                                label="Model Year"
                                value={this.state.editableFields.modelYear}
                                onChange={this.handleUpdate.bind( this )}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="useAmountValue"
                                isEditable={this.props.isEdit}
                                label="Machine Usage"
                                value={this.state.editableFields.useAmountValue}
                                onChange={this.handleUpdate.bind( this )}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="machineUseCode"
                                isEditable={false}
                                label="Machine Use Code"
                                value={this.useAmountUnit}
                            />
                        </div>

                    </div>
                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="customerEndUseCode"
                                isEditable={false}
                                label="End Use Of Product"
                                value={this.customerEndUseCode}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="useMonth"
                                isEditable={false}
                                label="Use Months"
                                value={this.useMonth}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="useYear"
                                isEditable={false}
                                label="Use Years"
                                value={this.useYear}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="branch"
                                isEditable={this.props.isEdit}
                                label="Branch"
                                value={this.state.editableFields.branch}
                                onChange={this.handleUpdate.bind( this )}
                            />
                        </div>
                    </div>
                    <div className="rows">
                        <div className={!this.props.isEdit ? 'four-cols date-range-picker non-editable' : 'four-cols date-range-picker'}>

                            <LabeledDatePicker
                                className="build-date"
                                selected={this.state.editableFields
                                    .buildDate === null ? 0
                                    : new Date( this.state.editableFields
                                        .buildDate )}
                                onChange={this.handleDateChange}
                                name="buildDate"
                                label="BuildDate"
                                maxDate={new Date()}
                                dateFormat="MM/dd/yyyy"
                                disabled={!this.props.isEdit}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="initialDeliveryDate"
                                isEditable={false}
                                label="Initial Delivery"
                                value={this.initialDeliveryDate}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="deliveryDate"
                                isEditable={false}
                                label="Current Delivery"
                                value={this.deliveryDate}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="warrantyExpirationDate"
                                isEditable={false}
                                label="Warranty Expiration"
                                value={this.warrantyExpirationDate}
                            />
                        </div>
                    </div>

                    <div className="rows">

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="powertrainWarrantyExpirationDate"
                                isEditable={false}
                                label="Power Train Expiraton"
                                value={this.powertrainWarrantyExpirationDate}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="extendedWarrantyCode"
                                isEditable={false}
                                label="Extended Warranty Code"
                                value={this.extendedWarrantyCode}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="participationCode"
                                isEditable={false}
                                label="Participation Code"
                                value={this.participationCode}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="policyAdjustmentCode"
                                isEditable={false}
                                label="Policy Adjustment Code"
                                value={this.policyAdjustmentCode}
                            />
                        </div>
                    </div>


                    <div className="rows">
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="warrantyCoverage"
                                isEditable={false}
                                label="Warranty Coverage"
                                value={this.warrantyCode}
                            />
                        </div>
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="totalDeductibleAmount"
                                isEditable={false}
                                label="Deductible Amount"
                                value={`$${this.totalDeductibleAmount}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="diagnosticAmount"
                                isEditable={false}
                                label="Diagnostic Amount"
                                value={`$${this.diagnosticAmount}`}
                            />
                        </div>

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="diagnosticHours"
                                isEditable={false}
                                label="Diagnostic Hours"
                                value={this.diagnosticHours}
                            />
                        </div>

                    </div>

                    <div className="rows">
                        {/*
                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="partsUse"
                                isEditable={false}
                                label="Parts Use"
                                value={this.partsUse}
                            />
                        </div>
                        */}

                        <div className="four-cols">
                            <LabeledInput
                                className="basic-claim-info"
                                name="installationDate"
                                isEditable={false}
                                label="Parts Purchase Date"
                                value={this.installationDate}
                            />
                        </div>

                    </div>

                </section>
            </div>

        );

    }

}

MachineWarranty.displayName = 'MachineWarranty';
MachineWarranty.propTypes = {
    claimDetails: PropTypes.object.isRequired,
    updateClaim: PropTypes.func.isRequired,
    isComponentEdit: PropTypes.bool.isRequired,
    enableEditCmp: PropTypes.func,
    isEdit: PropTypes.bool.isRequired,
};

export default MachineWarranty;
